export default __webpack_public_path__ + "static/media/AYW_Button.3eae2356.svg";